import './message.scss';

export default class Message {
  constructor() {
    let elem = document.createElement('div');
    elem.className = 'message-module-cont';
    let span = document.createElement('p');
    span.className = 'message-module-text';
    let img = document.createElement('div');
    let icon = document.createElement('div');
    img.className = 'message-module-img';
    icon.className = 'message-module-icon';
    elem.appendChild(icon);
    elem.appendChild(span);
    elem.appendChild(img);
    this.elem = elem;
    this.span = span;
    img.addEventListener('click', () => {
      this.destory();
    });
    this.append = false;
  }
  show(text, delay = 2000) {
    this.span.innerText = text;
    this.elem.style.display = 'block';
    if (!this.append) {
      this.append = true;
      document.body.appendChild(this.elem);
    }
    setTimeout(() => {
      this.destory();
    }, delay);
  }
  hide() {
    this.elem.style.display = 'none';
  }
  destory() {
    this.elem.remove();
    this.append = false;
  }
}
